@if (editType() !== EditType.DELETE) {
  <form (ngSubmit)="onSubmit(modalComponent())" class="p-3" autocomplete="off">
    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Date</label>
      <div class="col-sm-8">
        <div class="d-flex flex-row align-items-center flex-wrap">
          <div class="mb-3">
            <div class="input-group">
              <input class="form-control"
                     type="text"
                     [formField]="timeOffForm.date"
                     [minDate]="editDateAsNgbDate()"
                     ngbDatepicker
                     #startDate="ngbDatepicker">
              <button [disabled]="timeOffForm.date().disabled()"
                      class="btn btn-outline-secondary"
                      (click)="startDate.toggle()" type="button"><i class="fa fa-calendar-alt"></i>
              </button>
            </div>
          </div>
        </div>
        @if (timeOffForm.date().invalid() && timeOffForm.date().touched()) {
          <div class="form-error-message">
            @if (timeOffForm.date().errors()?.kind === 'required') {
              <p>Date is required</p>
            }
          </div>
        }
      </div>
    </div>
    <app-time-off-form-common-fields
            [fields]="timeOffForm.commonFields"
            [storeWorkingTime]="storeWorkingTime()">
    </app-time-off-form-common-fields>
    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent().activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="timeOffForm().invalid() || loading()">Save
      </button>
    </div>
  </form>
}
@if (editType() === EditType.DELETE) {
  <div>
    <div class="confirmation-text">
      Do you really want to delete preferred time off for {{ temporaryPreferredTimeOff()?.date }}?
    </div>
    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent().activeModal.close()">Close
      </button>
      <button class="btn btn-danger btn-form" type="button" (click)="onSubmit(modalComponent())" [disabled]="loading()">
        Delete
      </button>
    </div>
  </div>
}